import { ClockworkContext, ClockworkContextType } from '@/shared/contexts/Clockwork';
import { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import { isNull } from 'lodash';
import { dispatchSessionExpired } from './authEvents';
import { reportError, requestTelemetryHeaders } from '@/shared/services/analytics/errorTelemetry';

// Typ pro uchovávání ID requestů
const clockworkIds : string[] = [];

// Typ pro Axios interceptor
export const setupAxiosInterceptor = (axiosInstance : AxiosInstance, debug : ClockworkContextType | null) : void => {
    axiosInstance.interceptors.request.use((config) => {
        try {
            const apiUrl = process.env.NEXT_PUBLIC_API_URL;

            if (apiUrl && new URL(config.url ?? '', config.baseURL ?? apiUrl).origin === new URL(apiUrl).origin) {
                Object.assign(config.headers, requestTelemetryHeaders());
            }
        } catch {
            // Preserve the request if its URL or telemetry is unavailable.
        }

        return config;
    });
    axiosInstance.interceptors.response.use(
        (response : AxiosResponse) => {
            const clockworkId = response.headers['x-clockwork-id'] as string;

            if (clockworkId && !clockworkIds.includes(clockworkId) && !isNull(debug)) {
                ClockworkContext.addRequest({
                    id: clockworkId,
                    method: response.config.method!,
                    url: response.config.url!,
                    status: response.status,
                    time: new Date().toLocaleTimeString(),
                });
            }

            return response;
        },
        (error : AxiosError) => {
            reportError(error, { operation: 'api.request' });
            // 401 na requestu, který NESL token (uživatel se považoval za přihlášeného)
            // = vypršelá/zneplatněná session. Anonymní probe (fetchCurrentUser bez
            // tokenu) i selhání loginu Authorization hlavičku nemají → ticho, žádný allowlist.
            const wasAuthenticated = Boolean((error.config?.headers as Record<string, unknown> | undefined)?.Authorization);

            if (error.response?.status === 401 && wasAuthenticated) {
                dispatchSessionExpired();
            }

            return Promise.reject(error);
        },
    );
};

// Funkce pro získání všech ID requestů
export const getClockworkIds = () : string[] => {
    return clockworkIds;
};
